export const regionFacetsData = {
    "010006": {
        "name": "北海道",
        "hitcount": 0,
        "childDataDict": {},
    },
    "020001": {
        "name": "青森県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "030007": {
        "name": "岩手県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "040002": {
        "name": "宮城県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "050008": {
        "name": "秋田県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "060003":{
        "name": "山形県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "070009": {
        "name": "福島県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "080004": {
        "name": "茨城県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "090000": {
        "name": "栃木県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "100005": {
        "name": "群馬県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "110001":{
        "name": "埼玉県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "120006":{
        "name": "千葉県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "130001": {
        "name": "東京都",
        "hitcount": 0,
        "childDataDict": {},
    },
    "140007": {
        "name": "神奈川県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "150002": {
        "name": "新潟県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "160008": {
        "name": "富山県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "170003": {
        "name": "石川県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "180009": {
        "name": "福井県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "190004": {
        "name": "山梨県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "200000": {
        "name": "長野県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "210005": {
        "name": "岐阜県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "220001":{
        "name": "静岡県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "230006":{
        "name": "愛知県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "240001": {
        "name": "三重県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "250007": {
        "name": "滋賀県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "260002": {
        "name": "京都府",
        "hitcount": 0,
        "childDataDict": {},
    },
    "270008": {
        "name": "大阪府",
        "hitcount": 0,
        "childDataDict": {},
    },
    "280003": {
        "name": "兵庫県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "290009": {
        "name": "奈良県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "300004": {
        "name": "和歌山県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "310000":{
        "name": "鳥取県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "320005": {
        "name": "島根県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "330001": {
        "name": "岡山県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "340006": {
        "name": "広島県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "350001": {
        "name": "山口県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "360007": {
        "name": "徳島県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "370002": {
        "name": "香川県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "380008": {
        "name": "愛媛県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "390003": {
        "name": "高知県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "400009": {
        "name": "福岡県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "410004": {
        "name": "佐賀県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "420000": {
        "name": "長崎県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "430005":{
        "name": "熊本県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "440001":{
        "name": "大分県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "450006": {
        "name": "宮崎県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "460001":{
        "name": "鹿児島県",
        "hitcount": 0,
        "childDataDict": {},
    },
    "470007": {
        "name": "沖縄県",
        "hitcount": 0,
        "childDataDict": {},
    }
}